import React from 'react';

export interface HamburgerIconProps {
  className?: string;
}

const HamburgerIcon = ({ className }: HamburgerIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className={className}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M-.003 1a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v1.429a1 1 0 0 1-1 1h-22a1 1 0 0 1-1-1V1Zm0 10.429a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-22a1 1 0 0 1-1-1v-1Zm1 9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-22Z"
      clipRule="evenodd"
    />
  </svg>
);

export default HamburgerIcon;
